module.exports = __webpack_public_path__ + "img/slide5.a1102b6b.png";